export function mergeIndices(indices) {
    let merged = undefined;
    for (let i in indices) {
        let index = indices[i];
        if (index === undefined) {
            continue;
        }

        if (merged === undefined) {
            merged = index;
            continue;
        }

        merged = merge(merged, index);
    }

    return merged;
}

function merge(a, b) {
    let merged = {};

    for (let fieldType in a) {
        let fieldsA = a[fieldType]
        let fieldsB = b[fieldType]
        merged[fieldType] = {};
        for (let otherFieldType in fieldsA) {
            let listA = fieldsA[otherFieldType];
            let listB = fieldsB[otherFieldType];
            merged[fieldType][otherFieldType] = mergeList(listA, listB);
        }
    }
    return merged;
}

function mergeList(a, b) {
    let mapA = convertToMap(a);
    let mapB = convertToMap(b);

    let merged = {};
    for (let dimension in mapA) {
        if (dimension in mapB) {
            merged[dimension] = [... mapA[dimension], ... mapB[dimension]];
        } else {
            merged[dimension] = mapA[dimension];
        }
    }

    for (let dimension in mapB) {
        if (! (dimension in mapA)) {
            merged[dimension] = mapA[dimension];
        } 
    }
    return convertToList(merged);
}


function convertToMap(a) {
    let map = {};
    for (let i in a) {
        let item = a[i];
        map[item.dimension] = item.values;
    }
    return map;
}

function convertToList(a) {
    return Object.keys(a).map(
        dimension => ({
            dimension: dimension,
            values: a[dimension]
        }));
}
